
<template>
  <div class="layout--main" :class="[layoutTypeClass, navbarClasses, footerClasses, {'no-scroll': isAppPage}]">

    <vx-tour :steps="steps" v-if="!disableThemeTour && (windowWidth >= 1200 && mainLayoutType === 'vertical' && verticalNavMenuWidth == 'default')" />

    <the-customizer
      v-if                    = "!disableCustomizer"
      :footerType             = "footerType"
      :hideScrollToTop        = "hideScrollToTop"
      :navbarType             = "navbarType"
      :navbarColor            = "navbarColor"
      :routerTransition       = "routerTransition"
      @toggleHideScrollToTop  = "toggleHideScrollToTop"
      @updateFooter           = "updateFooter"
      @updateNavbar           = "updateNavbar"
      @updateNavbarColor      = "updateNavbarColor"
      @updateRouterTransition = "updateRouterTransition" />

    <v-nav-menu
      :navMenuItems = "navMenuItems"
      title         = "RedGirasol"
      parent        = ".layout--main" />

    <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">
      <div id="content-overlay" />

    <!-- Navbar -->
    <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
      <the-navbar-horizontal
        :navbarType= "navbarType"
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]" />

      <div style="height: 62px" v-if="navbarType === 'static'"></div>
      <h-nav-menu
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]"
        :navMenuItems="navMenuItems" />
    </template>

    <template v-else>
      <applicant-navbar-vertical
        :navbarColor="navbarColor"
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]" />
    </template>
    <!-- /Navbar -->

      <div class="content-wrapper">

        <div class="router-view">
          <div class="router-content">

            <transition :name="routerTransition">

              <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle" class="router-header flex flex-wrap items-center mb-6">
                <div
                  class="content-area__heading"
                  :class="{'pr-4 border-0 md:border-r border-solid border-grey-light' : $route.meta.breadcrumb}">
                  <h2 class="mb-1">{{ routeTitle }}</h2>
                </div>

                <!-- BREADCRUMB -->
                <vx-breadcrumb class="ml-4 md:block hidden" v-if="vxBreadcrumb" root="/solicitante" :breadcrumb="vxBreadcrumb" :isRTL="$vs.rtl" />

              </div>
            </transition>

            <div class="content-area__content">

              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle" @setActiveBreadcrumbTitle="setActiveBreadcrumbTitle" @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)" />
              </transition>
            </div>
          </div>
        </div>
      </div>


      <!-- Popup para inversion -->
      <vs-popup
        :active.sync="onIdleAlert"
        title="Tu sesión está a punto de expirar"
        :button-close-hidden="true">
        <idle-alert
          :timer="idleTimer"
          @on-continue-request="onContinueSessionRequest"
          @on-close-request="onCloseSessionRequest" />
      </vs-popup>

      <feedback-popup />
      <switch-account-popup />
      <app-footer :year="currentYear()" :footer_text="footerText" />
    </div>
  </div>
</template>


<script>
import HNavMenu            from '../components/horizontal-nav-menu/HorizontalNavMenu.vue'
import applicantNavMenuItems   from '../components/vertical-nav-menu/applicantNavMenuItems.js'
import TheCustomizer       from '../components/customizer/TheCustomizer.vue'
import TheNavbarHorizontal from '../components/navbar/TheNavbarHorizontal.vue'
import ApplicantNavbarVertical   from '../components/navbar/ApplicantNavbarVertical.vue'
import AppFooter           from '../components/AppFooter.vue'
import themeConfig         from '@/../themeConfigApplicant.js'
import VNavMenu            from '../components/vertical-nav-menu/VerticalNavMenu.vue'
import FeedbackPopup       from '../../components/FeedbackPopup.vue'
import {mapState} from "vuex";
import IdleAlert from "@components/session/IdleAlert";
import SwitchAccountPopup from "@components/SwitchAccountPopup";

import '@assets/css/applicants_investors.css'

export default {
  components: {
    HNavMenu,
    TheCustomizer,
    AppFooter,
    TheNavbarHorizontal,
    ApplicantNavbarVertical,
    VNavMenu,
    FeedbackPopup,
    IdleAlert,
    SwitchAccountPopup,
  },
  data () {
    return {
      disableCustomizer : themeConfig.disableCustomizer,
      disableThemeTour  : themeConfig.disableThemeTour,
      dynamicWatchers   : {},
      footerType        : themeConfig.footerType  || 'static',
      hideScrollToTop   : themeConfig.hideScrollToTop,
      isNavbarDark      : false,
      navbarColor       : themeConfig.navbarColor || '#fff',
      navbarType        : themeConfig.navbarType  || 'floating',
      //navMenuItems
      routerTransition  : themeConfig.routerTransition || 'none',
      routeTitle        : this.$route.meta.pageTitle,
      steps: [],
      vxBreadcrumb: null,
      onIdleAlert: false,
      idleSeconds: 45,
      idleTimer: 0,
      routes: [],
      invoiceMenuAdded: false,
      footerText: ""
    }
  },
  async mounted() {
    await this.setFooterText();
  },
  watch: {
    '$route' () {
      this.routeTitle = this.$route.meta.pageTitle;
      this.composeBreadcrumb();
    },
    isThemeDark (val) {
      const color = this.navbarColor === '#fff' && val ? '#10163a' : '#fff'
      this.updateNavbarColor(color)
    },
    '$store.state.mainLayoutType' (val) {
      this.setNavMenuVisibility(val)
      this.disableThemeTour = true
    }
  },
  async beforeMount(){
    // Sí no ha terminado onboarding, se muestra la pantalla de onboarding.
    if (this.ShowApplicantOnboarding) {
      this.$router.replace({name: 'applicantOnboarding'});
    }
  },
  computed: {
    ...mapState("auth", ["user"]),
    bodyOverlay () { return this.$store.state.bodyOverlay },    
    contentAreaClass () {
      if (this.mainLayoutType === 'vertical') {
        if      (this.verticalNavMenuWidth === 'default') return 'content-area-reduced'
        else if (this.verticalNavMenuWidth === 'reduced') return 'content-area-lg'
        else return 'content-area-full'
      } else return 'content-area-full'
    },
    footerClasses () {
      return {
        'footer-hidden': this.footerType === 'hidden',
        'footer-sticky': this.footerType === 'sticky',
        'footer-static': this.footerType === 'static'
      }
    },
    isAppPage () {
      return this.$route.meta.no_scroll
    },
    isThemeDark ()     { return this.$store.state.theme === 'dark' },
    layoutTypeClass () { return `main-${this.mainLayoutType}`      },
    mainLayoutType ()  { return this.$store.state.mainLayoutType   },
    navbarClasses ()   {
      return {
        'navbar-hidden'   : this.navbarType === 'hidden',
        'navbar-sticky'   : this.navbarType === 'sticky',
        'navbar-static'   : this.navbarType === 'static',
        'navbar-floating' : this.navbarType === 'floating'
      }
    },
    verticalNavMenuWidth () { return this.$store.state.verticalNavMenuWidth },
    windowWidth ()          { return this.$store.state.windowWidth },
    navMenuItems(){
      if (this.$acl.check('isApplicant')) {
        this.routes = Object.assign(applicantNavMenuItems, {})

        this.addInvoiceMenuItemIfIsRequired();

        let creditsMainMenu = this.routes.find(f => f.slug === "creditsMainMenu");

        creditsMainMenu.submenu = [];
        if (this.user.projects != null) {
            Object.keys(this.user.projects).forEach(key => {
              const project = this.user.projects[key];
              creditsMainMenu.submenu.push({url: '/solicitante/credito/'+project.id,name: project.alias});
            })
        }
        return this.routes;
      }

      return [];
    },
    showGeneralLog(){
      return this.$acl.check('isSupplier');
    }
  },
  onIdle() {
    if(!this.onIdleAlert && !this.$store.state.runningMatiProcess){
      this.onIdleAlert = true;
      this.idleTimer = this.idleSeconds;
      setTimeout(this.onTimer, 1000);
    }
  },
  onActive() {
    this.messageStr = 'Hello'
  },
  methods: {
    async addInvoiceMenuItemIfIsRequired() {
      const {data} = await axios.get(`/api/applicant/${this.user.client_id}`)
      let clientRequiredInvoice = data.required_invoice;

      if(clientRequiredInvoice) {
        const facturacionRoutes = this.routes.find(x => x.slug == "facturacion");
        if(facturacionRoutes) {
          const hasRetencionesMenu = facturacionRoutes.submenu.find(x => x.slug == "retenciones");
          if(hasRetencionesMenu == null) {
            facturacionRoutes.submenu.push({
                url: '/solicitante/facturacion/retenciones',
                name: 'Retenciones',
                slug: 'retenciones',
                icon: 'FileIcon',
                condition: 'show_applicant_menu_options',
            })
          }
        }  
      }    
      // if (!this.invoiceMenuAdded && clientRequiredInvoice) {
      //   this.routes.push({
      //     url: '/solicitante/facturacion',
      //     name: 'Facturacion',
      //     slug: 'facturacion',
      //     icon: 'FileIcon',
      //     condition: 'show_applicant_menu_options',
      //     submenu: [
      //       {
      //         url: '/solicitante/facturacion/csd',
      //         name: 'CSD',
      //         slug: 'csd',
      //         icon: 'FileIcon',
      //         condition: 'show_applicant_menu_options',
      //       },
      //       {
      //         url: '/solicitante/facturacion/retenciones',
      //         name: 'Retenciones',
      //         slug: 'retenciones',
      //         icon: 'FileIcon',
      //         condition: 'show_applicant_menu_options',
      //       }
      //     ]
      //   })

      //   this.invoiceMenuAdded = true;
      // }
    },
    async onContinueSessionRequest(){
      this.$store.commit("idleVue/IDLE_CHANGED", false);
      this.onIdleAlert = false;
    },
    async onCloseSessionRequest(){
      this.$store.commit("idleVue/IDLE_CHANGED", false);
      this.onIdleAlert = false;
      this.showFullPageLoader();
      //await this.$router.replace({name: 'investorsLogout'});
      await this.executeAppLogout();
    },
    async onTimer(){
      if(this.onIdleAlert && !this.$store.state.runningMatiProcess){
        this.idleTimer -= 1;
        if(this.idleTimer <= 0){
          this.$store.commit("idleVue/IDLE_CHANGED", false);
          this.onIdleAlert = false;
          this.showFullPageLoader();
          //await this.$router.replace({name: 'investorsLogout'});
          await this.executeSessionTimedLogout();
        }
        else {
          setTimeout(this.onTimer, 1000);
        }
      }
    },
    changeRouteTitle (title) {
      this.routeTitle = title
    },
    updateNavbar (val) {
      if (val === 'static') this.updateNavbarColor(this.isThemeDark ? '#10163a' : '#fff')
      this.navbarType = val
    },
    updateNavbarColor (val) {
      this.navbarColor = val
      if (val === '#fff') this.isNavbarDark = false
      else this.isNavbarDark = true
    },
    updateFooter (val) {
      this.footerType = val
    },
    currentYear(){
      return new Date().getFullYear();
    },
    async setFooterText() {
      await axios.get('/api/public-footer-text').then((response) => {
          this.footerText = response.data;
      });
    },
    updateRouterTransition (val) {
      this.routerTransition = val
    },
    setNavMenuVisibility (layoutType) {
      if ((layoutType === 'horizontal' && this.windowWidth >= 1200) || (layoutType === 'vertical' && this.windowWidth < 1200)) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
      } else {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
      }
    },
    setActiveBreadcrumbTitle(title){
      this.vxBreadcrumb.find(f => f.active).title = title;
    },
    toggleHideScrollToTop (val) {
      this.hideScrollToTop = val
    },
    composeBreadcrumb() {
      let route = this.$route;
      let bread = [];
      if(route.meta.breadcrumb){
        route.meta.breadcrumb.forEach(rlink => {
          let link = {url: rlink.url, title: rlink.title, active: rlink.active };
          if(link.url && link.url.includes('{')){
            link.url = this.replaceParams(route, link.url);
          }
          if(link.title && link.title.includes('{')){
            link.title = this.replaceParams(route, link.title);
          }
          bread.push(link);
        });
        this.vxBreadcrumb = bread;
      }
      else {
        this.vxBreadcrumb = null;
      }
    },
  },
  created () {
    const color = this.navbarColor === '#fff' && this.isThemeDark ? '#10163a' : this.navbarColor
    this.updateNavbarColor(color)
    this.setNavMenuVisibility(this.$store.state.mainLayoutType)

    // Dynamic Watchers for tour
    // Reason: Once tour is disabled it is not required to enable it.
    // So, watcher is required for just disabling it.
    this.dynamicWatchers.windowWidth = this.$watch('$store.state.windowWidth', (val) => {
      if (val < 1200) {
        this.disableThemeTour = true
        this.dynamicWatchers.windowWidth()
      }
    })

    this.dynamicWatchers.verticalNavMenuWidth = this.$watch('$store.state.verticalNavMenuWidth', () => {
      this.disableThemeTour = true
      this.dynamicWatchers.verticalNavMenuWidth()
    })

    this.dynamicWatchers.rtl = this.$watch('$vs.rtl', () => {
      this.disableThemeTour = true
      this.dynamicWatchers.rtl()
    })

    this.composeBreadcrumb();
  },
  beforeDestroy () {
    Object.keys(this.dynamicWatchers).map(i => {
      this.dynamicWatchers[i]()
      delete this.dynamicWatchers[i]
    })
  }
}

</script>
